import React from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import authorLogo from "../../assets/images/antecna-logo.svg";
import privrednaKomoraLogo from "../../assets/images/privredna_komora_logo.svg";

const StyledHomeFooterContainer = styled(Box)`
    position: fixed;
    flex-direction: column;
    bottom: 0;
    height: 70px;
    width: 100%;
`;

const StyledGradientBox = styled.div`
    height: 1px;
    background: linear-gradient(90deg, rgb(64, 132, 186), rgb(149, 71, 155), rgb(190, 60, 78), rgb(246, 137, 88), rgb(250, 187, 27));
    bottom: 10px;
    position: relative;
    z-index: -5;
`;

const StyledLogoContainer = styled(Flex)`
    flex-direction: row;
    // justify-content: space-between;
    justify-content: end;
    flex: 1;
`;

const StyledImage = styled.img`
    height: 20%;
    width: 22%;
`;

const StyledImageBig = styled.img`
    height: 22%;
    width: 30%;
    margin-top: 2vh;
`;

const HomeFooter = () => {
    const openAntecnaSite = () => {
        window.open("web:https://www.antecna.com/", "_system");
    };

  /*  const openPrivrednaKomoraSite = () => {
        window.open("web:https://komorars.ba/", "_system");
    };*/

    return (
        <StyledHomeFooterContainer>
            <StyledLogoContainer paddingX={[4, 5]}>
                <StyledImage onClick={openAntecnaSite} src={authorLogo} />
            </StyledLogoContainer>
            <StyledGradientBox />
        </StyledHomeFooterContainer>
    );
};

export default HomeFooter;
